import React from 'react'

const InfoBoxes = ({
        data,
    }) => {
    return data.map(
        ({data, header, additionalStyles}, index) => returnBox(data, header, additionalStyles, index));
};

function returnBox(data, header, additionalStyle = null, index){
    return <div className="info-box-item" key={index}>
        <div className="info-box-header">
            {header}
        </div>
        <div className="info-box-body" style={additionalStyle}>
            {data}
        </div>
    </div>
}

export default InfoBoxes